export default __webpack_public_path__ + "6c8375e158ffcf1688cd4b5e855a7c7f.png";